import { render, staticRenderFns } from "./TabelaAtualizarPrecos.vue?vue&type=template&id=238a07f3&scoped=true&"
import script from "./TabelaAtualizarPrecos.vue?vue&type=script&lang=js&"
export * from "./TabelaAtualizarPrecos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAtualizarPrecos.vue?vue&type=style&index=0&id=238a07f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a07f3",
  null
  
)

export default component.exports